import { useEffect, useCallback } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Gera um ID único para o visitante (armazenado no localStorage)
const getVisitorId = () => {
  let visitorId = localStorage.getItem('multicell_visitor_id');
  if (!visitorId) {
    visitorId = 'v_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();
    localStorage.setItem('multicell_visitor_id', visitorId);
  }
  return visitorId;
};

/**
 * Hook para rastrear visualizações de página
 * @param {string} pageType - Tipo da página: 'home', 'catalog', 'product', 'cart'
 * @param {string} productId - ID do produto (apenas para páginas de produto)
 */
export const usePageView = (pageType, productId = null) => {
  useEffect(() => {
    const trackView = async () => {
      try {
        const visitorId = getVisitorId();
        
        await fetch(`${API_URL}/api/public/analytics/view`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            page_type: pageType,
            product_id: productId,
            visitor_id: visitorId,
            referer: document.referrer || null
          })
        });
      } catch (error) {
        // Silently fail - não afeta UX
        console.debug('Analytics tracking failed:', error);
      }
    };

    // Pequeno delay para não afetar carregamento da página
    const timer = setTimeout(trackView, 500);
    
    return () => clearTimeout(timer);
  }, [pageType, productId]);
};

/**
 * Função para rastrear eventos específicos (ex: clique em botão WhatsApp)
 */
export const trackEvent = async (eventType, data = {}) => {
  try {
    const visitorId = getVisitorId();
    
    await fetch(`${API_URL}/api/public/analytics/view`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        page_type: `event_${eventType}`,
        visitor_id: visitorId,
        ...data
      })
    });
  } catch (error) {
    console.debug('Event tracking failed:', error);
  }
};

export default usePageView;
